module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Views.c8478fdf.PNG";